import { useEffect, useState } from 'react';
import { b2bApi } from '../../api/client';
import { formatCurrency } from '../../lib/currency';

const STATUS_LABELS = { PENDING: 'In afwachting', CONFIRMED: 'Bevestigd', REJECTED: 'Afgewezen' };
const STATUS_COLORS = { PENDING: 'bg-yellow-100 text-yellow-800', CONFIRMED: 'bg-green-100 text-green-800', REJECTED: 'bg-red-100 text-red-700' };

export default function B2BReferrals() {
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    b2bApi.referrals().then(r => setReferrals(r.data)).finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only load
  }, []);

  return (
    <div data-testid="b2b-referrals-page" className="p-8">
      <div className="mb-8">
        <h1 className="font-serif text-3xl font-light text-foreground">Referrals</h1>
        <p className="text-sm text-muted-foreground mt-1">{referrals.length} referrals</p>
      </div>

      {loading ? (
        <div className="space-y-2">{[...Array(4)].map((_, i) => <div key={`referrals-skeleton-${i}`} className="h-14 bg-muted rounded-xl animate-pulse" />)}</div>
      ) : referrals.length === 0 ? (
        <div className="text-center py-16 border border-dashed border-border rounded-2xl text-muted-foreground">
          <p className="font-serif text-xl">Nog geen referrals</p>
          <p className="text-sm mt-2">Referrals verschijnen hier wanneer klanten via uw link bestellen.</p>
        </div>
      ) : (
        <div className="bg-card border border-border rounded-2xl overflow-hidden shadow-sm">
          <table className="w-full text-sm">
            <thead className="bg-muted/50 text-muted-foreground text-xs uppercase tracking-wider">
              <tr>
                <th className="px-5 py-3.5 text-left font-semibold">Bestelnr.</th>
                <th className="px-5 py-3.5 text-left font-semibold">Datum</th>
                <th className="px-5 py-3.5 text-right font-semibold">Orderbedrag</th>
                <th className="px-5 py-3.5 text-center font-semibold">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {referrals.map(r => (
                <tr key={r._id} className="hover:bg-muted/20 transition-colors">
                  <td className="px-5 py-3.5 font-mono text-foreground">{r.order ? `#${r.order.orderNumber}` : '--'}</td>
                  <td className="px-5 py-3.5 text-muted-foreground">{new Date(r.created_at).toLocaleDateString('nl-BE', { dateStyle: 'medium' })}</td>
                  <td className="px-5 py-3.5 text-right">{r.order ? formatCurrency(r.order.totalAmount, 'nl') : '--'}</td>
                  <td className="px-5 py-3.5 text-center">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${STATUS_COLORS[r.status] || 'bg-muted text-muted-foreground'}`}>
                      {STATUS_LABELS[r.status] || r.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
